import MsSwitch from './src/Switch.vue'

export default MsSwitch